import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectProfile = createSelector(
  [(store: RootState) => store.profileDetail?.profile],
  (usersList) => usersList
);
